import {
  recordMatchesDivision,
  type DivisionScopedRecord,
  type OperationalDivision,
} from './operationalDivisions'

export type DivisionSelection = Pick<OperationalDivision, 'id' | 'service_types'>
export type DivisionScopedRow = DivisionScopedRecord

export function matchesDivision(
  row: DivisionScopedRow | null | undefined,
  division: DivisionSelection | null | undefined
): boolean {
  if (!row) return !division
  return recordMatchesDivision(row, division ? (division as OperationalDivision) : null)
}

export function matchesDivisionWithFallback(
  primary: DivisionScopedRow | null | undefined,
  division: DivisionSelection | null | undefined,
  ...fallbacks: Array<DivisionScopedRow | null | undefined>
): boolean {
  if (!division) return true
  if (primary?.operational_division_id) return primary.operational_division_id === division.id

  const serviceType =
    primary?.service_type ||
    fallbacks.find((row) => row?.operational_division_id)?.service_type ||
    fallbacks.find((row) => row?.service_type)?.service_type
  const assignedDivision = fallbacks.find((row) => row?.operational_division_id)?.operational_division_id

  if (assignedDivision) return assignedDivision === division.id
  return !!serviceType && (division.service_types || []).includes(serviceType)
}
